import { config } from 'affiny-core/env';
import { ActionsUnion, createAction } from 'affiny-core/modules/helpers';

export enum EGoToRateCardActionType {
  GO_TO = 'RATECARD/GO_TO',
}

export interface IGoToRateCardActionParams {
  actionCode: number;
  redirectToExternalLink?: (url: string) => void;
  returnRouteOk?: string;
  returnRouteKo?: string;
}

export const getReturnRoute = () => {
  const returnRoute = window.location.pathname;

  if (config.env.publicBasePath) {
    return returnRoute.replace(config.env.publicBasePath, '');
  }

  return returnRoute;
};

export const goToRateCardActions = {
  goToRateCard: ({
    actionCode,
    returnRouteOk,
    returnRouteKo,
  }: IGoToRateCardActionParams) =>
    createAction(EGoToRateCardActionType.GO_TO, {
      actionCode,
      redirectToExternalLink: (url: string) => {
        window.location.href = url;
      },
      returnRouteOk: returnRouteOk ? returnRouteOk : getReturnRoute(),
      returnRouteKo: returnRouteKo ? returnRouteKo : getReturnRoute(),
    }),
};

export type IGoToRateCardAction = ActionsUnion<typeof goToRateCardActions>;
